import { getPlural } from 'client/utils/plural';

export const getVdpPfButtonText = ({ photoCount }) => `${photoCount} ${getPlural('Photo', photoCount)}`;
export const getVdpPfButtonSROnlyText = photoCount =>
  `Open Vehicle Image Viewer (${photoCount} ${getPlural('Photo', photoCount)})`;
